import { MinzeElement, Attrs } from 'minze'

export interface LvcAddIcon {}

export class LvcAddIcon extends MinzeElement {
  attrs: Attrs = [['data-color', 'white']]
  html = () => `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Add">
  <path id="Icon" d="M18.125 10C15.3951 10.236 12.6542 10.3513 9.91192 10.3456M9.91192 10.3456C7.24728 10.3402 4.53391 10.2336 1.875 10M9.91192 10.3456C9.67085 7.58959 9.91105 4.8476 10 1.875M9.91192 10.3456C10.0036 13.3273 9.84565 15.2871 10 18.125" stroke="${this.dataColor || 'white'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  </svg>
  `

  css = () => `
    
  `
}
